import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./swal.scss";

const reactSwal = withReactContent(Swal);

export default reactSwal;
